import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { AuditLogApiService } from './audit-log-api-service';
import { IAuditLog } from '../../listing/interfaces/audit-log';

export class AuditLogDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<IAuditLog[]> = new BehaviorSubject([]);
  constructor(protected Api: AuditLogApiService, private readonly role: any) {
    super();
  }

  protected loadData(PageEvent: PageEvent) {
    return this.Api.listWithPageEvent(this.role, this.filter.value, PageEvent);
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }
}
